'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resize = resize;
exports.clearResize = clearResize;
exports.scroll = scroll;
exports.clearScroll = clearScroll;
exports.mousemove = mousemove;
exports.clearMousemove = clearMousemove;
exports.throttle = throttle;
/**
 * @homeaway/raf-optimized
 * Inspired by https://developer.mozilla.org/en-US/docs/Web/Events/resize
 *
 **/

var _clientWidth = -1;
var _clientHeight = -1;
var _scrollTop = -1;
var _scrollLeft = -1;
var _mouseX = -1;
var _mouseY = -1;
var _resizeQueue = [];
var _scrollQueue = [];
var _mouseQueue = [];
var _init = false;

/**
 * addThrottleHandler()
 * add request animation frame throttled event handler function
 * @param {*} type
 * @param {*} callback
 * @param {*} obj
 */
var addThrottleHandler = exports.addThrottleHandler = function addThrottleHandler(type, callback, obj) {
    if (typeof obj !== 'undefined' || typeof window !== 'undefined') {
        obj = obj || window;
        if (!obj.addEventListener) {
            return false;
        }
        var running = false;
        var func = function func(originalEvent) {
            if (running) {
                return;
            }
            running = true;
            requestAnimationFrame(function () {
                callback(originalEvent);
                running = false;
            });
        };
        obj.addEventListener(type, func);
        return function () {
            obj.removeEventListener(type, func);
        };
    }
    return false;
};

function init() {
    if (_init === true) {
        return true;
    }
    if (typeof window === 'undefined') {
        return false;
    }

    var supportWindowScrollObj = window.scrollY !== undefined;

    function getClientWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function getClientHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }

    function getClientScrollTop() {
        return supportWindowScrollObj ? window.scrollY : document.documentElement.scrollTop || document.body.scrollTop;
    }

    function getClientScrollLeft() {
        return supportWindowScrollObj ? window.scrollX : document.documentElement.scrollLeft || document.body.scrollLeft;
    }

    _clientWidth = getClientWidth();
    _clientHeight = getClientHeight();
    _scrollTop = getClientScrollTop();
    _scrollLeft = getClientScrollLeft();

    function handleResize() {
        if (_resizeQueue.length > 0) {
            var clientWidth = getClientWidth();
            var clientHeight = getClientHeight();
            var didResize = !!(_clientWidth !== clientWidth || _clientHeight !== clientHeight);

            if (didResize) {
                for (var i = 0; i < _resizeQueue.length; i++) {
                    _resizeQueue[i]({
                        width: clientWidth,
                        height: clientHeight
                    });
                }
            }
            _clientWidth = clientWidth;
            _clientHeight = clientHeight;
        }
    }

    function handleScroll() {
        if (_scrollQueue.length > 0) {
            var scrollTop = getClientScrollTop();
            var scrollLeft = getClientScrollLeft();
            var didVerticalScroll = scrollTop !== _scrollTop;
            var didHorizontalScroll = scrollLeft !== _scrollLeft;
            var direction = (didVerticalScroll ? scrollTop > _scrollTop ? 'down' : 'up' : null) || (didHorizontalScroll ? scrollLeft > _scrollLeft ? 'right' : 'left' : null);

            if (didVerticalScroll || didHorizontalScroll) {
                for (var i = 0; i < _scrollQueue.length; i++) {
                    _scrollQueue[i]({ scrollTop: scrollTop, scrollLeft: scrollLeft, direction: direction });
                }
            }
            _scrollTop = scrollTop;
            _scrollLeft = scrollLeft;
        }
    }

    function handleMouseMove(event) {
        if (_mouseQueue.length > 0) {
            var mouseX = event.x;
            var mouseY = event.y;

            var didVerticalMouse = mouseY !== _mouseY;
            var didHorizontalMouse = mouseX !== _mouseX;
            var distance = Math.abs(mouseY - _mouseY) + Math.abs(mouseX - _mouseX);

            var direction = (didVerticalMouse ? mouseY > _mouseY ? 'down' : 'up' : 'none') + ':' + (didHorizontalMouse ? mouseX > _mouseX ? 'right' : 'left' : 'none');

            if (didVerticalMouse || didHorizontalMouse) {
                for (var i = 0; i < _mouseQueue.length; i++) {
                    _mouseQueue[i]({ mouseX: mouseX, mouseY: mouseY, direction: direction, distance: distance });
                }
            }
            _mouseX = mouseX;
            _mouseY = mouseY;
        }
    }

    /* init - you can init any event */
    addThrottleHandler('resize', handleResize);
    addThrottleHandler('scroll', handleScroll);
    addThrottleHandler('mousemove', handleMouseMove);

    /* Do not re-initialize this */
    _init = true;

    return true;
}

/**
 * resize()
 * {function} cb - function to be called when rAF optimized resize event occurs
 * TODO: support unregister
 */
function resize(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _resizeQueue.push(cb);

    return function removeCallback() {
        var index = _resizeQueue.indexOf(cb);

        if (index >= 0) {
            _resizeQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearResize()
 * Clears resize queue
 */
function clearResize() {
    _resizeQueue = [];
}

/**
 * scroll()
 * {function} cb - function to be called when rAF optimized scroll event occurs
 * TODO: support unregister
 */
function scroll(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _scrollQueue.push(cb);

    return function removeCallback() {
        var index = _scrollQueue.indexOf(cb);

        if (index >= 0) {
            _scrollQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearScroll()
 * Clears the scroll queue
 */
function clearScroll() {
    _scrollQueue = [];
}

/**
 * mousemove()
 * {function} cb - function to be called when mousemove occurs
 */
function mousemove(cb) {
    if (typeof cb !== 'function' || init() === false) {
        return false;
    }
    _mouseQueue.push(cb);

    return function removeCallback() {
        var index = _mouseQueue.indexOf(cb);

        if (index >= 0) {
            _mouseQueue.splice(index, 1);
            return true;
        }
        return false;
    };
}

/**
 * clearScroll()
 * Clears the scroll queue
 */
function clearMousemove() {
    _mouseQueue = [];
}

/**
 * throttle()
 * Simple throttle function
 * @param {*} fn
 * @param {*} wait
 */
function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
}

// Export API to window object
if (typeof window !== 'undefined' && !window.rafoptimized) {
    window.rafoptimized = {
        scroll: scroll,
        resize: resize,
        mousemove: mousemove,
        addThrottleHandler: addThrottleHandler
    };
}
//# sourceMappingURL=index.js.map